import { render, staticRenderFns } from "./AddShipmentModal.vue?vue&type=template&id=3a037de6&scoped=true&"
import script from "./AddShipmentModal.vue?vue&type=script&lang=js&"
export * from "./AddShipmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a037de6",
  null
  
)

export default component.exports